"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformLeadPassengerToContact = transformLeadPassengerToContact;
const Contact_1 = require("../models/Contact");
function transformLeadPassengerToContact(passenger) {
    const contact = new Contact_1.Contact();
    contact.birthdayAt = passenger.birthdayAt;
    contact.countryId = passenger.countryId;
    contact.email = passenger.email;
    contact.firstName = passenger.firstName;
    contact.lastName = passenger.lastName;
    contact.phoneNumber = passenger.phoneNumber;
    return contact;
}
//# sourceMappingURL=transformLeadPassengerToContact.js.map